<template>
  <div class="conmain">
     <div v-if="liad_show">
          <load></load>
        </div>
    <el-button type="primary" round @click="type_up('add','','')">新增分类</el-button>
    <el-tree ref="tree" :data="type_list" node-key="type_list.num"  draggable :expand-on-click-node="false">
        <span class="custom-tree-node" slot-scope="{data}">
          <div class="left">{{ data.name }}</div>
          <div class="right">
            <el-button type="text" size="mini" @click="type_up('edit',data.num,'')">
              编辑分类
            </el-button>
            <el-button type="text" size="mini" @click="type_up('add','',data.num)">
              添加子分类
            </el-button>
            <el-button type="text" size="mini" @click="() => remove(data.num)">
              删除分类
            </el-button>
          </div>
        </span>
    </el-tree>

    <el-dialog title="所属分类":visible.sync="nav_status.type_choice_dialog" :before-close="handleClose">
      <div style="display: flex;">
        <div class="ercitankuang_left">
          <el-tree   @node-click="type_fid"
             :data="type_list"
              ref="tree"
              node-key="num"
             :default-expanded-keys="tree_default"
             :props="defaultProps">
         </el-tree>
        </div>
        <div class="ercitankuang_content">
          <i class="el-icon-right"></i>
        </div>
          <div class="ercitankuang_right">
           <div v-html="type_choiced.html" @click="del_type_edit_fid_click($event)"></div>
          </div>
      </div>

       <div slot="footer" class="dialog-footer">
         <el-button @click="type_choice_remove()">取 消</el-button>
         <el-button type="primary" @click="nav_status.type_choice_dialog = false">确 定</el-button>
       </div>
    </el-dialog>

    <!--新增分类-->
    <el-dialog :title="nav_status.type_edit_title ":visible.sync="nav_status.type_edit_dialog">
      <el-form :model="type_edit">
        <el-form-item label="分类名称" :label-width="formLabelWidth">
          <el-input v-model="type_edit.name" style="width: 80%;"  placeholder="分类名称"></el-input>
        </el-form-item>
        <el-form-item label="所属" :label-width="formLabelWidth">
          <div v-html="type_choiced.html" @click="del_type_edit_fid_click($event)"></div>
         <el-button plain @click="type_choice()">请选择</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="nav_status.type_edit_dialog = false">取 消</el-button>
        <el-button type="primary" @click="type_save()">确 定</el-button>
      </div>
    </el-dialog>


  </div>

</template>

<script>
  import load from '../../../../components/load.vue';
  export default {
    data() {
      return {
        nav_status:{
          type_edit_dialog:false,
          type_choice_dialog:false,
          type_edit_title:''
        },
        dialogFormVisible: false,
        form: {
          name: '',
          region: '',
        },
        formLabelWidth: '20%',
        type_list:[],
        type_edit:{
          type:'',
          fid:{},
        },
        type_choiced:{
          html:''
        },
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        formLabelWidth: '20%',
        tree_default:[],
      }
    },
    components: {load:load},
    mounted() {
      this.get_type()
    },
    methods: {
     get_type(){
       let _this=this
       _this.liad_show=true
       _this.axios.get('/v2/c_train/get_train_resource_type').then(function(res) {
         if(res.status=='200'){
           if(res.data.code=='1'){
             _this.type_list=res.data.data
              _this.liad_show=false
           }else{
             _this.$message.error(res.msg)
           }
         }else{
           _this.$message.error('服务器内部错误')
         }
       }).catch(function(error) {
         _this.$message.error('服务器内部错误')
       });
     },

      type_up(type,num,fid){
        let _this=this
        _this.type_choiced.html=''
        _this.type_edit={}
        _this.type_edit.fid={}
        _this.type_edit.type=type
        if(num!=''){
          _this.type_edit.num=num
          _this.get_type_info('edit',num);
        }
        if(fid!=''){
          _this.get_type_info('add',fid)
        }
        _this.nav_status.type_edit_dialog=true
      },

      type_choice(){
        this.nav_status.type_choice_dialog=true
      },

      type_fid(data){
        let _this=this
        _this.type_choiced.html=''
        _this.type_edit.fid={}
        _this.save_type_edit_fid(data)
      },

      change_type_choiced(){
        let _this=this
        _this.type_choiced.html=''
        for(let key  in _this.type_edit.fid){
          _this.type_choiced.html+="<span>"+_this.type_edit.fid[key]+"<span class='"+key+"' style='padding:0 20px;cursor:pointer'>X</span></span>"
        }
      },

      del_type_edit_fid_click:function(event){
        let _this=this
        if(event.target.className){
          _this.del_type_edit_fid(event.target.className)
        }else{
          return false;
        }
      },

      save_type_edit_fid(data){
        let _this=this
        _this.type_edit.fid[data.num]=data.name
        _this.change_type_choiced()
      },

      del_type_edit_fid(num){
        let _this=this
        delete _this.type_edit.fid[num];
        _this.change_type_choiced()
      },

      type_choice_remove(done){
        let _this=this
        _this.$confirm('确认取消所选分类？').then(_ => {
          _this.type_choiced=''
          _this.type_edit.fid={}
          done();
        })
        .catch(_ => {});
      },

      handleClose(done) {
        let _this=this
        _this.$confirm('确认所选分类？').then(_ => {
          done();
        })
        .catch(_ => {});
      },

      get_type_up_data(){
        let _this=this
        var data={}
        data.type=_this.type_edit.type
        data.name=_this.type_edit.name
        if(_this.type_edit.hasOwnProperty('num')){
          data.num=_this.type_edit.num
        }
        data.fid=_this.type_edit.fid
        var temp=Array()
        for(var key in data.fid){
          temp.push(key)
        }
        data.fid=temp
        return data
      },
      //上传
      type_save(){
        let _this=this
        var data=_this.get_type_up_data()
        _this.axios.post("/v2/c_train/train_resource_type_up",{data:data}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.$message.success(res.data.msg);
              _this.nav_status.type_edit_dialog=false
              _this.get_type();
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      get_type_info(type,num){
        let _this = this
        _this.axios.get("/v2/c_train/get_train_resource_type_info",{params:{'num':num}}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              if(type=='add'){
                _this.save_type_edit_fid(res.data.data)
              }else{
                _this.$set(_this.type_edit,'name',res.data.data.name)
                if(res.data.data.fid!='0'){
                    _this.get_type_info('add',res.data.data.fid)
                }
                _this.nav_status.type_edit_dialog=false
                _this.nav_status.type_edit_dialog=true
              }
            } else {
              _this.$message.error(res.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      remove(num) {
        let _this=this
        _this.$confirm('此操作将永久删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var data={
            'type':'del',
            'num':num
          }
          _this.axios.post("/v2/c_train/train_resource_type_up",{data:data}).then(function (res) {
            if (res.status == "200") {
              if (res.data.code == "1") {
                _this.$message.success(res.data.msg);
                _this.get_type()
              } else {
                _this.$message.error(res.data.msg);
              }
            } else {
              _this.$message.error("服务器内部错误");
            }
          })
        }).catch(() => {
          _this.$message.info('已取消删除');
        });

      },

    }
  }
</script>

<style scoped>
  .conmain {
    width: 100%;
    height: 100%;
  }

  .el-tree {
    width: 100%;
  }

  >>>.el-tree>.el-tree-node {
    width: calc(100% - 45px);
    border: 2px solid #f6f8ff;
    box-shadow: 5px 5px 3px #f6f8ff;
    padding: 20px;
  }

  .custom-tree-node {
    width: 100%;
    margin: 10px 0;
    z-index: 99;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/train/ResourcesPack/Class.vue